export const DEFAULT_LINE_HEIGHT = 35;
export const DEFAULT_ICON_SIZE = 24;
export const GIFT_CARD_LAST_CHARS = 5;
export const CHECK_LAST_CHARS = 4;